import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class FicheClientService {

    API: string = environment.baseURL;

    constructor(
        private httpClient: HttpClient
    ) { }

    getFicheClient(request: { nbByPage: number, start: number, search: { name?: string }, token: string }): Observable<any> {
         const { nbByPage, start, search, token } = request;

        let params = new HttpParams()
            .set('nbByPage', nbByPage.toString())
            .set('start', start)
            .set('token', token);

        if (search.name) {
            params = params.set('columnSearch', search.name);
        }
        return this.httpClient.get(
            `${this.API}/get-fiche-client`, { params }
        );
    }

    getFicheClientDetail(id: string): Observable<any> {

        let params = new HttpParams()
            .set('id', id)

        return this.httpClient.get(
            `${this.API}/get-fiche-client-detail`, { params }
        );
    }
}
